<template>
    <ul class="dropdown-menu pull-left">
        <template v-for="(item) in items" >
            <Li @click="$emit('click', $event)"  v-if="$root.user.permissions.includes(item.permission) && checkOnAllowedRole(item, $root.user)" :to="item.to" :href="item.href" :params="item.params" :blank="item.blank" :key="item.to">{{ item.name }}</Li>
        </template>
    </ul>
</template>

<script>

import Li from "@/js/components/_Layouts/HeaderMenu/Li.vue";
import { hasRole } from '@/js/services/auth-service';

export default {
    name: "Ul",
    components: {Li},

    props: {
        parentRoles: {
            type: Array,
            default: () => []
        },
        items: {
            type: Array,
            default: () => []
        }
    },

    methods: {
        checkOnAllowedRole(menuItem, user) {
            //return true;
            let isAllowed = false;

            if (Object.hasOwn(menuItem, 'roles')) {
                isAllowed = hasRole(user, menuItem.roles);
            } else {
                // if item in menu doesn't have roles, we check parent roles on whole menu item
                isAllowed = hasRole(user, this.parentRoles)
            }

            return isAllowed;
        }
    },
}
</script>

<style scoped>

</style>
